import Status from "components/common/Status";
import WidgetPanel from "components/common/WidgetPanel";
import Invoice from "interfaces/response/Invoice";
import { Variant } from "shared/enums/VariantEnum";
import informationIconSvg from "static/images/information-icon-red.svg";
import {
  getFullDateFromString,
  getMonthAndDayOrdinalString,
} from "shared/utility/DateTimeUtility";
import NextPaymentDetails from "interfaces/response/NextPaymentDetails";
import { NextPaymentDetailsType } from "shared/enums/NextPaymentDetailsTypeEnum";
import Button from "components/common/controls/Button";
import { useHistory } from "react-router";
import * as routePath from "shared/constants/RoutePathConstants";
import { getRemainingGracePeriodDays } from "shared/utility/InvoiceHelper";

interface Props {
  invoice: Invoice;
  nextPaymentDetails: NextPaymentDetails;
}

export default function InvoiceSummary(props: Props) {
  const { invoice, nextPaymentDetails } = props;
  const history = useHistory();

  const handleViewInvoicesClick = () => {
    history.push(routePath.INVOICES);
  };

  return (
    <div>
      <WidgetPanel
        displayHeader={false}
        displaySecondaryHeaderOnSmallScreen
        title={"Last invoice"}
      >
        <div className="flex gap-x-4 gap-y-2 text-sm items-center flex-wrap">
          <div className="flex">
            <div className="font-semibold mr-1">Last invoice:</div>
            <span>{getFullDateFromString(invoice.created)}</span>
          </div>
          <div className="flex">
            <div className="font-semibold mr-1">Description:</div>
            <div>
              Invoice {getMonthAndDayOrdinalString(invoice.periodStart)} to{" "}
              {getMonthAndDayOrdinalString(invoice.periodEnd)}
            </div>
          </div>
          <div>
            <Status
              variant={invoice.isPaid ? Variant.Success : Variant.Danger}
              text={invoice.isPaid ? "paid" : "failed"}
            />
          </div>
        </div>
      </WidgetPanel>
      {nextPaymentDetails &&
        nextPaymentDetails.type === NextPaymentDetailsType.GracePeriod && (
          <div className="bg-promGray5 px-6 py-4 rounded-b flex gap-y-4 justify-between flex-wrap">
            <div className="flex items-center">
              <img src={informationIconSvg} alt="information" />
              <div className="ml-4 text-sm flex flex-wrap gap-y-2 gap-x-4">
                <p>
                  Your last{" "}
                  <span className="text-promRed1 font-bold">
                    payment failed
                  </span>
                  .
                </p>
                <p>
                  Grace days remaining:{" "}
                  <span className="font-bold">
                    {getRemainingGracePeriodDays(nextPaymentDetails.date)}
                  </span>
                </p>
              </div>
            </div>
            <div>
              <Button text="VIEW INVOICES" onClick={handleViewInvoicesClick} />
            </div>
          </div>
        )}
    </div>
  );
}
